export default __webpack_public_path__ + "static/media/ic_lock.63fbdafc.svg";